import { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import React from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import IdlePopUp_New from "./IdleconfrimpopUp";

export default function EreExtensionPopUp({
  PopUp,
  setPopUp,
  popUpData,
  setTrigger,
  trigger,
  routeType,
  isEdit,
  Cancelshow,
}) {
  console.log(
    "Page data log to be printed in the console .... annual",
    popUpData
  );
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();

  const [selectedOption, setSelectedOption] = useState({
    sla_borne: "",
    sla_paybale: "",
    client_borne: "",
    client_paybale: "",
    employee_borne: "",
    employee_paybale: "",
  });
  const [selectedOptionMain, setSelectedOptionMain] = useState({});
  const [amount, setAmount] = useState("");
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };
  const [duration, setDuration] = useState("");
  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };
  const handleOptionChangeMain = (event) => {
    const { name, value } = event.target;
    setSelectedOptionMain((prevSelectedOption) => ({
      ...prevSelectedOption,
      [name]: value,
    }));
  };
  console.log("popUpData..........", popUpData);
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      [name]: value,
    }));
  };
  const [daysUntilExpiry, setDaysUntilExpiry] = useState(null);

  const [data, setData] = useState();

  const response = async () => {
    const endPoint =
      routeType === "Emergency_leave"
        ? `/ere/getDetails/${popUpData?.candidate_id}`
        : routeType === "Annual_Vacation"
          ? `/employeeAnnualvacation/getEmpDetails/${popUpData?.candidate_id}`
          : "";

    try {
      const res = await nodeinstance.get(`${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setData(res?.data?.data);
      }
    } catch (error) {
      console.log("error.........", error);
      dispatch(
        setAppError({
          msg: "failed to get the data",
        })
      );
    }
  };

  useEffect(() => {
    const calculateDaysUntilExpiry = () => {
      const expiryDate = popUpData?.iqama_expiry_date_g
        ? new Date(popUpData?.iqama_expiry_date_g)
        : new Date();
      const today = new Date();

      const timeDifference = expiryDate - today; // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days and round up

      setDaysUntilExpiry(daysDifference);
    };

    calculateDaysUntilExpiry();
    // if (isEdit) {
    console.log("successs.........");
    response();
    // }
  }, []);

  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();

  const onSubmit = async () => {
    if (duration > daysUntilExpiry) {
      dispatch(
        setAppError({
          msg: "Iqama valid days extends",
          // color: "success",
        })
      );
      return;
    }
    const ConditionObject =
      routeType === "Emergency_leave"
        ? { emergency_leave_status: "ERE EXTENSION-PAYMENT DONE" }
        : { annual_vacation_status: "ERE EXTENSION-PAYMENT DONE" };
    const reqObject = {
      ...selectedOptionMain,
      amount: amount,
      iqama_valid_days_remaining: daysUntilExpiry,
      employee_id: popUpData?.candidate_id,
      employeeExtendDuration: duration,

      extension_sla_fees:
        selectedOption.sla_borne != "" && selectedOption.sla_paybale != ""
          ? "BOTH"
          : selectedOption.sla_borne != ""
            ? "BORNE"
            : selectedOption.sla_paybale != ""
              ? "PAYBALE"
              : "",
      extension_employee_fees:
        selectedOption.employee_borne != "" &&
        selectedOption.employee_paybale != ""
          ? "BOTH"
          : selectedOption.employee_borne != ""
            ? "BORNE"
            : selectedOption.employee_paybale != ""
              ? "PAYBALE"
              : "",
      extension_client_fees:
        selectedOption.client_borne != "" && selectedOption.client_paybale != ""
          ? "BOTH"
          : selectedOption.client_borne != ""
            ? "BORNE"
            : selectedOption.client_paybale != ""
              ? "PAYBALE"
              : "",
    };
    const filteredReqObject = Object.fromEntries(
      Object.entries(reqObject).filter(([_, value]) => value !== "")
    );
    const newObj = { ...ConditionObject, ...filteredReqObject };
    const endPoint =
      routeType === "Annual_Vacation"
        ? "/employeeAnnualvacation/annualVacation"
        : routeType === "Emergency_leave"
          ? `/ere/emergencyLeave`
          : "";
    try {
      const response = await nodeinstance.put(`${endPoint}`, newObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setPopUp(false);
        setTrigger(!trigger);
        dispatch(
          setAppError({
            msg: "Updated successfully...",
            color: "success",
          })
        );
        return;
      }
    } catch (error) {
      console.log("error.....", error);
      dispatch(
        setAppError({
          msg: "Failed to update the status",
        })
      );
    }
  };
  console.log("daysUntilExpiry......", data);

  useEffect(() => {
    setSelectedOptionMain((prevSelectedOption) => ({
      ...prevSelectedOption,
      extension_govt_cost: data?.extension_govt_cost,
      extension_salary: data?.extension_salary,
      extension_ere_type: data?.extension_ere_type,
    }));
    if (isEdit) {
      setAmount(data?.amount);
    }
    setDuration(data?.employeeExtendDuration);
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      sla_borne:
        data?.extension_sla_fees === null
          ? ""
          : data?.extension_sla_fees === "BORNE"
            ? "BORNE"
            : data?.extension_sla_fees === "BOTH"
              ? "BORNE"
              : "",
      sla_paybale:
        data?.extension_sla_fees === null
          ? ""
          : data?.extension_sla_fees === "PAYBALE"
            ? "PAYABLE"
            : data?.extension_sla_fees === "BOTH"
              ? "PAYABLE"
              : "",
      client_borne:
        data?.extension_client_fees === null
          ? ""
          : data?.extension_client_fees === "BORNE"
            ? "BORNE"
            : data?.extension_client_fees === "BOTH"
              ? "BORNE"
              : "",
      client_paybale:
        data?.extension_client_fees === null
          ? ""
          : data?.extension_client_fees === "PAYBALE"
            ? "PAYABLE"
            : data?.extension_client_fees === "BOTH"
              ? "PAYABLE"
              : "",
      employee_borne:
        data?.extension_employee_fees === null
          ? ""
          : data?.extension_employee_fees === "BORNE"
            ? "BORNE"
            : data?.extension_employee_fees === "BOTH"
              ? "BORNE"
              : "",
      employee_paybale:
        data?.extension_employee_fees === null
          ? ""
          : data?.extension_employee_fees === "PAYBALE"
            ? "PAYABLE"
            : data?.extension_employee_fees === "BOTH"
              ? "PAYABLE"
              : "",
    }));
  }, [data]);

  const [cancelOpen, setCancelOpen] = useState(false);
  const cancelRequest = () => {
    setCancelOpen(true);
  };

  const [extendBeforeDate, setExtendBeforeDate] = useState("");

  const [extendAfterDate, setExtendAfterDate] = useState();

  const handleExtendBefore = (e) => {
    setExtendBeforeDate(e.target.value);
  };

  const handleExtendAfter = (e) => {
    setExtendAfterDate(e.target.value);
  };

  const submitHandler = async (e, fileData) => {
    if (popUpData.Annual_vacation_status === "ON ERE EXTENSION_ISSUED") {
      console.log(".......type........");
      return;
    }
    console.log("fileData......", selectedOption);
    // e.preventDefault();

    const endPoint =
      routeType === "Annual_Vacation"
        ? "/employeeAnnualvacation/extensionIssueEre"
        : routeType === "Emergency_leave"
          ? `/ere/extensionIssueEre`
          : "";

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("employee_id", popUpData?.candidate_id);
      formData.append("emergency_leave_status", "ON ERE EXTENSION_ISSUED");
      formData.append("annual_vacation_status", "ON ERE EXTENSION_ISSUED");
      formData.append("extension_exit_before_date", data?.exit_before_date);
      if (extendBeforeDate != "") {
        formData.append("extension_entry_before_date", extendBeforeDate);
      }

      const response = await nodeinstance.put(`${endPoint}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        // alert("dbgcycdyu.........");
        setPopUp(false);
        setTrigger(!trigger);
        dispatch(
          setAppError({
            msg: "Updated successfully...",
            color: "success",
          })
        );
        return;
      }
    } catch (error) {
      console.log("hbdcgggftdcygygydcf........");
    }
  };

  const formatISODateToInputDate = (isoDate) => {
    const date = new Date(isoDate);
    // Get the date in YYYY-MM-DD format
    return date.toISOString().split("T")[0];
  };

  // const [cancelClick]
  const handleClearClick = () => {
    setSelectedOption({});
  };
  const [lastRadio, setLastRadio] = useState("");
  const handleRadioChange = (e) => {
    setLastRadio(e.target.value);
  };
  const notReturnLastClick = async () => {
    try {
      const obj = {
        employee_id: popUpData?.candidate_id,
        project_id: popUpData?.project_unique_id,
        demobilization_date: popUpData?.demobilization_date,
      };
      const endPoint =
        routeType === "Annual_Vacation"
          ? "/employeeAnnualvacation/AnnualvacationNotReturn"
          : routeType === "Emergency_leave"
            ? `/ere/erenotreturn`
            : "";
      const response = await nodeinstance.put(`${endPoint}`, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setPopUp(false);
        setTrigger(!trigger);
        dispatch(
          setAppError({
            msg: "Updated successfully...",
            color: "success",
          })
        );
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-2xl max-h-[45rem]  w-full h-auto mt-4 rounded-md overflow-scroll bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {isEdit ? (
            <>
              {/* <form onSubmit={(e) => submitHandler(e, file)} className="w-full"> */}
              <div className="bg-orange-50 p-3 ">
                <div className="flex items-center space-x-8 font-bold">
                  <label>PAYROLL & BILLING</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">GOVT. COST:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_govt_cost"
                        value="BORNE BY CLIENT"
                        checked={
                          selectedOptionMain?.extension_govt_cost ===
                          "BORNE BY CLIENT"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> BORNE BY CLIENT</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        value="BORNE BY SLA"
                        name="extension_govt_cost"
                        checked={
                          selectedOptionMain?.extension_govt_cost ===
                          "BORNE BY SLA"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> BORNE BY SLA</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
                <div className="flex gap-2">
                  <label className="pr-2">SALARY:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_salary"
                        value="PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOptionMain?.extension_salary ===
                          "PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> PAYABLE TO EMPLOYEE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_salary"
                        value="NOT PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOptionMain?.extension_salary ===
                          "NOT PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> NOT PAYABLE TO EMPLOYEE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
              </div>
              <br />
              {/* Second face */}
              <div className="bg-orange-50 p-3">
                <div className="flex items-center space-x-2 ">
                  <label className="font-bold">ERE TYPE</label>
                  <label>
                    COUNT OF PAST ERE INSTANCE:{" "}
                    {routeType === "Emergency_leave"
                      ? popUpData.Emergency_leave_instance
                      : popUpData.Annual_leave_instance}
                  </label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">TYPE:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_ere_type"
                        value="SINGLE"
                        checked={
                          selectedOptionMain?.extension_ere_type === "SINGLE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> SINGLE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_ere_type"
                        value="MULTIPLE"
                        checked={
                          selectedOptionMain?.extension_ere_type === "MULTIPLE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> MULTIPLE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>

                <div className="flex flex-wrap items-center">
                  <label className="mr-2">DURATION:</label>
                  <input
                    type="text"
                    className={`input input-sm h-8 max-w-xs 
                          input-bordered focus:outline-none uppercase`}
                    required
                    value={duration}
                    disabled={isEdit}
                    // value={daysUntilExpiry}
                  />
                  <label className="block font-xs uppercase ml-2 text-xs">
                    IQAMA Valid days remaining: <br /> {daysUntilExpiry}
                  </label>
                </div>
              </div>
              <br />
              <div className="bg-orange-50 p-3">
                <div className="flex items-center justify-end space-x-2 mt-1">
                  {/* <label className="font-bold mt-4">FEES</label> */}
                  <button
                    className="bg-red px-4 py-2 text-sm rounded hover:bg-gray-300 text-white"
                    onClick={() => {
                      handleClearClick();
                    }}
                    disabled={isEdit}
                  >
                    Clear Filter
                  </button>
                </div>
                <div className="grid grid-cols-4 gap-4">
                  {/* Client */}
                  <div>
                    <label className="block font-bold">Client</label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="client_borne"
                        value="BORNE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.client_borne === "BORNE"}
                        disabled={
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.employee_borne === "BORNE" ||
                          selectedOption?.employee_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      BORNE
                    </label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="client_paybale"
                        value="PAYABLE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.client_paybale === "PAYABLE"}
                        disabled={
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.employee_borne === "BORNE" ||
                          selectedOption?.sla_paybale === "PAYABLE" ||
                          selectedOption?.employee_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      PAYABLE/PAID
                    </label>
                  </div>

                  {/* SLA */}
                  <div>
                    <label className="block font-bold">SLA</label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="sla_borne"
                        value="BORNE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.sla_borne === "BORNE"}
                        disabled={
                          selectedOption?.client_borne === "BORNE" ||
                          selectedOption?.employee_borne === "BORNE" ||
                          isEdit
                        }
                      />
                      BORNE
                    </label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="sla_paybale"
                        value="PAYABLE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.sla_paybale === "PAYABLE"}
                        disabled={
                          selectedOption?.client_paybale === "PAYABLE" ||
                          selectedOption?.employee_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      PAYABLE/PAID
                    </label>
                  </div>

                  {/* Employee */}
                  <div>
                    <label className="block font-bold">Employee</label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="employee_borne"
                        value="BORNE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.employee_borne === "BORNE"}
                        disabled={
                          selectedOption?.client_borne === "BORNE" ||
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.client_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      BORNE
                    </label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="employee_paybale"
                        value="PAYABLE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.employee_paybale === "PAYABLE"}
                        disabled={
                          selectedOption?.client_paybale === "PAYABLE" ||
                          selectedOption?.client_borne === "BORNE" ||
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.sla_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      PAYABLE/PAID
                    </label>
                  </div>
                </div>
              </div>
              <div className="bg-orange-50 p-3">
                <div className="flex items-center space-x-2 ">
                  <label className="font-bold">TOTAL AMOUNT : </label>
                  {/* <label>COUNT OF PAST ERE INSTANCE: 1</label> */}
                  <input
                    type="number"
                    name="amount"
                    className={`input input-sm h-8 max-w-xs  w-full 
                      input-bordered focus:outline-none uppercase mb-2 mt-2`}
                    required="er"
                    value={amount}
                    onChange={handleAmountChange}
                    disabled={isEdit}
                    // onChange={}
                  />
                </div>
              </div>
              <br />
              <div className="bg-orange-50 p-3">
                <div className="flex gap-2 mb-4 mt-4">
                  <label className="pr-2">CHANGE STATUS:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        value="ERE EXTENSION"
                        checked={
                          selectedOption === "ERE EXTENSION" || isEdit === true
                        }
                        onChange={handleOptionChange}
                        disabled={isEdit}
                      />
                      <p> ERE EXTENSION</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        value="NOT RETURN FROM ERE"
                        checked={selectedOption === "NOT RETURN FROM ERE"}
                        onChange={handleOptionChange}
                        disabled={isEdit}
                      />
                      <p> NOT RETURN FROM ERE</p>
                    </label>
                  </div>
                </div>
              </div>
              {isEdit === true ? (
                <div className="bg-orange-50 p-3">
                  <div className="items-center space-x-2">
                    <label className="font-bold">Extended ISSUE ERE</label>
                  </div>
                  <div className="flex align-center gap-8 mb-5">
                    <p>Extended EXIT BEFORE</p>
                    <input
                      type="date"
                      id="field2"
                      className={`input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase`}
                      required
                      // min={data?.entry_before_date.split("T")[0]}
                      value={
                        data?.exit_before_date
                          ? formatISODateToInputDate(data?.exit_before_date)
                          : ""
                      }
                      // onChange={handleExtendAfter}
                      disabled
                    />
                  </div>
                  <div className="flex align-center gap-8">
                    <p> Extended ENTRY BEFORE</p>
                    <input
                      type="date"
                      id="field2"
                      className={`input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase`}
                      required
                      min={data?.exit_before_date.split("T")[0]}
                      value={
                        extendBeforeDate
                          ? extendBeforeDate
                          : data?.extension_entry_before_date
                            ? formatISODateToInputDate(
                                data?.extension_entry_before_date
                              )
                            : ""
                      }
                      onChange={handleExtendBefore}
                      disabled={
                        popUpData.emergency_leave_status ===
                          "ON ERE EXTENSION_ISSUED" ||
                        popUpData.Annual_vacation_status ===
                          "ON ERE EXTENSION_ISSUED"
                      }
                    />
                  </div>
                  {popUpData.emergency_leave_status ===
                    "ON ERE EXTENSION_ISSUED" ||
                  popUpData.Annual_vacation_status ===
                    "ON ERE EXTENSION_ISSUED" ? (
                    ""
                  ) : (
                    <>
                      <input
                        type="file"
                        className="file-input file-input-bordered w-1/2 mt-2"
                        onChange={(e) => setFile(e.target.files[0])}
                        required
                        accept="application/xls, application/xlsx"
                      />
                      <h1>
                        <span className="text-red">
                          (* File type should be .PDF)
                        </span>
                      </h1>
                    </>
                  )}
                </div>
              ) : (
                ""
              )}
              {popUpData.emergency_leave_status === "ON ERE EXTENSION_ISSUED" ||
              popUpData.Annual_vacation_status === "ON ERE EXTENSION_ISSUED" ? (
                ""
              ) : (
                <div className="flex w-full">
                  <div className="w-full flex flex-col gap-3">
                    <div className="flex gap-3 w-full justify-center">
                      <button
                        className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                        onClick={() => submitHandler()}
                        // type="submit"
                        disabled={
                          popUpData.emergency_leave_status ===
                            "ON ERE EXTENSION_ISSUED" ||
                          popUpData.Annual_vacation_status ===
                            "ON ERE EXTENSION_ISSUED"
                        }
                      >
                        <p>Submit</p>
                        {loading ? <CgSpinner className="animate-spin" /> : ""}
                      </button>
                    </div>
                  </div>

                  <div className="w-full flex flex-col gap-3">
                    <div className="flex gap-3 w-full justify-center">
                      <button
                        className="p-3 bg-black text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                        onClick={() => {
                          // setPopUp(false);
                          cancelRequest();
                        }}
                      >
                        <p>
                          {!Cancelshow ? "CANCEL REQUEST" : "Returned from ERE"}{" "}
                        </p>
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* </form> */}
              {popUpData.emergency_leave_status === "ON ERE EXTENSION_ISSUED" ||
              popUpData.Annual_vacation_status === "ON ERE EXTENSION_ISSUED" ? (
                <div className="bg-orange-50 p-3">
                  <div className="flex gap-2 mb-4 mt-4">
                    <label className="pr-2">CHANGE STATUS:</label>

                    <div className="flex gap-5">
                      <label className="flex gap-x-1">
                        <input
                          type="radio"
                          value="NOT RETURN FROM ERE"
                          checked={lastRadio === "NOT RETURN FROM ERE"}
                          onChange={handleRadioChange}
                        />
                        <p> NOT RETURN FROM ERE</p>
                      </label>
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="w-full flex flex-col gap-3">
                      <div className="flex gap-3 w-full justify-center">
                        <button
                          className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                          onClick={() => {
                            notReturnLastClick();
                          }}
                        >
                          <p>Submit</p>
                        </button>
                      </div>
                    </div>
                    <div className="w-full flex flex-col gap-3">
                      <div className="flex gap-3 w-full justify-center">
                        <button
                          className="p-3 bg-black text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                          onClick={() => {
                            // setPopUp(false);
                            cancelRequest();
                          }}
                        >
                          <p>
                            {!Cancelshow
                              ? "CANCEL REQUEST"
                              : "Returned from ERE"}{" "}
                          </p>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <div className="bg-orange-50 p-3 ">
                <div className="flex items-center space-x-8 font-bold">
                  <label>PAYROLL & BILLING</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">GOVT. COST:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_govt_cost"
                        value="BORNE BY CLIENT"
                        checked={
                          selectedOptionMain?.extension_govt_cost ===
                          "BORNE BY CLIENT"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> BORNE BY CLIENT</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        value="BORNE BY SLA"
                        name="extension_govt_cost"
                        checked={
                          selectedOptionMain?.extension_govt_cost ===
                          "BORNE BY SLA"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> BORNE BY SLA</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
                <div className="flex gap-2">
                  <label className="pr-2">SALARY:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_salary"
                        value="PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOptionMain?.extension_salary ===
                          "PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> PAYABLE TO EMPLOYEE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_salary"
                        value="NOT PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOptionMain?.extension_salary ===
                          "NOT PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> NOT PAYABLE TO EMPLOYEE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
              </div>
              <br />
              {/* Second face */}
              <div className="bg-orange-50 p-3">
                <div className="flex items-center space-x-2 ">
                  <label className="font-bold">ERE TYPE</label>
                  <label>COUNT OF PAST ERE INSTANCE: 1</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">TYPE:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_ere_type"
                        value="SINGLE"
                        checked={
                          selectedOptionMain?.extension_ere_type === "SINGLE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> SINGLE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_ere_type"
                        value="MULTIPLE"
                        checked={
                          selectedOptionMain?.extension_ere_type === "MULTIPLE"
                        }
                        onChange={handleOptionChangeMain}
                        disabled={isEdit}
                      />
                      <p> MULTIPLE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>

                <div className="flex flex-wrap items-center">
                  <label className="mr-2">DURATION:</label>
                  <input
                    type="text"
                    className={`input input-sm h-8 max-w-xs 
                         input-bordered focus:outline-none uppercase`}
                    required
                    onChange={handleDurationChange}
                    value={duration}
                    // value={daysUntilExpiry}
                  />
                  <label className="block font-xs uppercase ml-2 text-xs">
                    IQAMA Valid days remaining: <br /> {daysUntilExpiry}
                  </label>
                </div>
              </div>
              <br />
              <div className="bg-orange-50 p-3">
                <div className="flex items-center justify-end space-x-2 mt-1">
                  {/* <label className="font-bold mt-4">FEES</label> */}
                  <button
                    className="bg-red px-4 py-2 text-sm rounded hover:bg-gray-300 text-white"
                    onClick={() => {
                      handleClearClick();
                    }}
                    disabled={isEdit}
                  >
                    Clear Filter
                  </button>
                </div>
                <div className="grid grid-cols-4 gap-4">
                  {/* Client */}
                  <div>
                    <label className="block font-bold">Client</label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="client_borne"
                        value="BORNE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.client_borne === "BORNE"}
                        disabled={
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.employee_borne === "BORNE" ||
                          selectedOption?.employee_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      BORNE
                    </label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="client_paybale"
                        value="PAYABLE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.client_paybale === "PAYABLE"}
                        disabled={
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.employee_borne === "BORNE" ||
                          selectedOption?.sla_paybale === "PAYABLE" ||
                          selectedOption?.employee_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      PAYABLE/PAID
                    </label>
                  </div>

                  {/* SLA */}
                  <div>
                    <label className="block font-bold">SLA</label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="sla_borne"
                        value="BORNE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.sla_borne === "BORNE"}
                        disabled={
                          selectedOption?.client_borne === "BORNE" ||
                          selectedOption?.employee_borne === "BORNE" ||
                          isEdit
                        }
                      />
                      BORNE
                    </label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="sla_paybale"
                        value="PAYABLE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.sla_paybale === "PAYABLE"}
                        disabled={
                          selectedOption?.client_paybale === "PAYABLE" ||
                          selectedOption?.employee_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      PAYABLE/PAID
                    </label>
                  </div>

                  {/* Employee */}
                  <div>
                    <label className="block font-bold">Employee</label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="employee_borne"
                        value="BORNE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.employee_borne === "BORNE"}
                        disabled={
                          selectedOption?.client_borne === "BORNE" ||
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.client_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      BORNE
                    </label>
                    <label className="flex items-center gap-x-2 mt-2">
                      <input
                        type="radio"
                        name="employee_paybale"
                        value="PAYABLE"
                        onChange={handleOptionChange}
                        checked={selectedOption?.employee_paybale === "PAYABLE"}
                        disabled={
                          selectedOption?.client_borne === "BORNE" ||
                          selectedOption?.sla_borne === "BORNE" ||
                          selectedOption?.sla_paybale === "PAYABLE" ||
                          selectedOption?.client_paybale === "PAYABLE" ||
                          isEdit
                        }
                      />
                      PAYABLE/PAID
                    </label>
                  </div>
                </div>
              </div>

              <div className="bg-orange-50 p-3">
                <div className="flex items-center space-x-2 ">
                  <label className="font-bold">TOTAL AMOUNT : </label>
                  {/* <label>COUNT OF PAST ERE INSTANCE: 1</label> */}
                  <input
                    type="number"
                    name="amount"
                    className={`input input-sm h-8 max-w-xs  w-full 
                      input-bordered focus:outline-none uppercase mb-2 mt-2`}
                    required="er"
                    value={amount}
                    onChange={handleAmountChange}
                    disabled={isEdit}
                    // onChange={}
                  />
                </div>
              </div>

              <br />
              <div className="flex w-full">
                <div className="w-full flex flex-col gap-3">
                  <div className="flex gap-3 w-full justify-center">
                    <button
                      className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                      onClick={() => onSubmit()}
                    >
                      <p>Submit</p>
                      {loading ? <CgSpinner className="animate-spin" /> : ""}
                    </button>
                  </div>
                </div>

                <div className="w-full flex flex-col gap-3">
                  <div className="flex gap-3 w-full justify-center">
                    <button
                      className="p-3 bg-black text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                      onClick={() => {
                        // setPopUp(false);
                        cancelRequest();
                      }}
                    >
                      <p>
                        {!Cancelshow ? "CANCEL REQUEST" : "Returned from ERE"}{" "}
                      </p>
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {cancelOpen ? (
        <IdlePopUp_New
          cancelOpen={cancelOpen}
          setCancelOpen={setCancelOpen}
          setPopUp={setPopUp}
          popUpData={popUpData}
          trigger={trigger}
          setTrigger={setTrigger}
          routeType={routeType}
          showDate={
            popUpData.emergency_leave_status != null ||
            popUpData.Annual_vacation_status != null
              ? true
              : false
          }
        />
      ) : (
        ""
      )}
    </>
  );
}
